import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

import { ref, onBeforeMount } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import { clueToInvalid } from '@/api/marketing/marketingManage'
import { listByParamCodes } from '@/api/common'
import type { ParamCodeItem } from '@/typings/common'
import type { ClueManage } from '@/typings/api/marketingManage'
import { selectForNumberValidate } from '@/utils/validate'
import { paramCodesDataFilter } from '@/utils/index'

const __default__ = { name: 'invalidModel' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String
  }
},
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {



const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  zbu_invalid_reason_fbu: [] // 无效原因
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_zbu',
    paramCodes: ['zbu_invalid_reason_fbu']
  }).then((res) => {
    // 递归过滤业务参数状态
    res.data = paramCodesDataFilter(res.data, 0)
    paramCodeData.value = res.data
  })
}
onBeforeMount(() => {
  getByParamCodes()
})

const data = ref<ClueManage[]>([])
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
const editForm = ref<any>({})
const emit = __emit
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    clueToInvalid(editForm.value)
      .then(() => {
        visible.value = false
        emit('success')
        DcMessage.success('置为无效线索成功')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const toggle = (rows: ClueManage[]) => {
  // 验证数量
  if (!rows || rows.length < 1) {
    DcMessage.error('请选择数据！')
    return
  }
  // 校验状态
  const errorRow = rows.find((item) => item.clueStatus !== 0 || item.clueType === 3)
  if (errorRow) {
    DcMessage.error('请选择未投放的有效线索！')
    return
  }
  data.value = rows
  editForm.value = {
    clueIdList: rows.map((item) => item.clueId)
  }
  visible.value = true
}
__expose({
  toggle
})

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
    title: "置为无效",
    class: "clueMerge",
    width: "670px",
    onOk: handleSubmit,
    confirmLoading: loading.value
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: editForm.value,
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "clueIdList",
                label: "客户名称",
                rules: [{ required: true, message: '请输入' }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: editForm.value.clueIdList,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((editForm.value.clueIdList) = $event)),
                    mode: "tags",
                    placeholder: "请选择",
                    disabled: true
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: item.clueId,
                          value: item.clueId
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.customerName), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "invalidId",
                label: "无效原因",
                rules: {
          message: '请选择',
          validator: _unref(selectForNumberValidate),
          required: true
        }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ParamCodesSelect, {
                    value: editForm.value.invalidId,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((editForm.value.invalidId) = $event)),
                    options: paramCodeData.value.zbu_invalid_reason_fbu,
                    allowClear: ""
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              }, 8, ["rules"]),
              _createVNode(_component_a_form_item, {
                name: "remark",
                label: "备注"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CosTextarea, {
                    value: editForm.value.remark,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((editForm.value.remark) = $event)),
                    maxlength: 2000,
                    placeholder: "请输入"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "confirmLoading"]))
}
}

})